import ptBR from './pt-br.json';
import enUS from './en-us.json';
import esES from './es-es.json';
export const resources = {
    'pt-BR': ptBR,
    'en-US': enUS,
    'es-ES': esES
};
//# sourceMappingURL=index.js.map